// Client-safe constants and enums
// This file contains only enums and pure constants - NO database imports
// Import ApplicationPlatform locally for the constant definition
import { ApplicationPlatform, SurveyPresentationCondition } from "./generated/browser";
export * from "./generated/browser";
// Pure constants (no database dependency)
export const ApplicationPlatformStringMap = {
    [ApplicationPlatform.STRIPE]: "Web 2 App",
    [ApplicationPlatform.ANDROID]: "Android",
    [ApplicationPlatform.IOS]: "iOS",
    [ApplicationPlatform.WEB]: "Stripe",
    [ApplicationPlatform.PADDLE]: "Paddle",
    [ApplicationPlatform.PROMOTIONAL]: "Promotional"
};
export const ReadablePresentationConditions = {
    [SurveyPresentationCondition.ON_MANUAL_CLOSE]: "When the user closes the paywall.",
    [SurveyPresentationCondition.ON_PURCHASE]: "After the user purchases."
};
